var mainMenuNavigationApp = angular.module("mainMenuNavigation", ["core", "ui.bootstrap", "ngSanitize"]);

mainMenuNavigationApp.config(["$locationProvider", function ($locationProvider) {
    $locationProvider.html5Mode(true);
}]);

angular.module("mainMenuNavigation").directive("mainMenuLink", ["viewsLocation", "Inflector", "$timeout", function (viewsLocation, Inflector, $timeout) {

    return {
        restrict: "E",
        replace: true,
        templateUrl: viewsLocation + "/MainMenuLink.html",
        scope: {
            item: "=",
            button: "=",
            toplevel: "=",
            component: "@",
            viewall: "=?",
            showthumbnail: "=?",
            label: "@"
        },
        link: function (scope, element, attributes) {
            $timeout(function() {
                if (scope.toplevel === true) {

                    if (scope.component == "mega") {

                        element.parent().parent().on("mouseleave", function (e) {
                            $(".dropdown-menu.menu-" + scope.item.uniqueId).attr("style", "display: none");
                            $(".dropdown-menu.menu-" + scope.item.uniqueId).hide();
                        });

                        element.on("mouseenter", function (e) {
                            if (attributes.href !== null) {
                                e.stopPropagation();
                            }

                            $(".main-menu-navigation").find(".dropdown-menu").not((".dropdown-menu.menu-" + scope.item.uniqueId)).attr("style", "display: none");
                            $(".dropdown-menu.menu-" + scope.item.uniqueId).toggle();
                            $(".dropdown-menu.menu-" + scope.item.uniqueId).attr("style", "display: inline-block !important");
                        });

                    } else if (scope.component == "meganest") {

                        element.parent().parent().on("mouseleave", function (e) {
                            $(".dropdown-menu.menu-" + scope.item.uniqueId).hide();
                        });

                        element.on("mouseenter", function (e) {
                            e.stopPropagation();
                            e.preventDefault();

                            $(".megamenu-content-column").attr("style", "display: none !important");
                            $(".main-menu-navigation").find(".dropdown-menu").not((".dropdown-menu.menu-" + scope.item.uniqueId)).hide();
                            $(".dropdown-menu.menu-" + scope.item.uniqueId).toggle();
                        });

                    } else {
                        element.on("mouseenter", function (e) {
                            $(this).next(".dropdown-menu").show();
                            $(".main-menu-navigation").find(".dropdown-menu").not($(this).next(".dropdown-menu")).hide();
                        });

                        element.parent().on("mouseleave", function (e) {
                            element.next(".dropdown-menu").hide();
                        });
                    }
                }
            });
        }
    };
}]);

angular.module("mainMenuNavigation").directive("mainMenuNavigation", ["viewsLocation", "Inflector", "$timeout", function (viewsLocation, Inflector, $timeout) {

    var LAYOUT_DEFAULT = "dropdown_nested";
    var LAYOUT_MEGAMENU = "megamenu_nested";
    var LAYOUT_THUMBNAILS = "megamenu_thumbnails";
    var LAYOUT_DROPMEGA = "dropdown_megamenu";
    var MEGAMENU_NUM_COLUMNS = 4;
    var NOT_COLLAPSED_ATTR = "in";
    var DEFAULT_CATEGORY_DEPTH = 6;
    var DEFAULT_LIST_LIMIT= 20;

    function getChunkedItems($scope) {
        var items = angular.copy($scope.items);

        for (var i = 0; i < items.length; i++) {

            if (items[i].items) {
                if ($scope.layoutId === LAYOUT_DROPMEGA) {
                    for (var m = 0; m < items[i].items.length; m++) {
                        if (items[i].items[m].items) {
                            items[i].items[m].items = chunkSubItems(items[i].items[m].items, $scope.megaMenuNumCols);
                        }
                    }
                } else {
                    items[i].items = chunkSubItems(items[i].items, $scope.megaMenuNumCols);
                }
            }
        }

        return items;
    }

    function chunkSubItems(arr, numCols) {
        function getChunkSize(arr, numCols, i) {
            return Math.max(Math.ceil(arr.length / (numCols - i)), 1);
        }

        var newArr = [];
        var slice = [];
        var i = 0;

        while (arr.length) {
            chunkSize = getChunkSize(arr, numCols, i);
            slice = angular.copy(arr.slice(0, chunkSize));
            arr = arr.slice(slice.length, arr.length);
            i++;

            newArr.push(slice);
        }

        return newArr;
    }

    function isMegaMenu(scope) {
        switch (scope.layoutId) {
            case LAYOUT_MEGAMENU:
            case LAYOUT_THUMBNAILS:
            case LAYOUT_DROPMEGA:
                return true;
            case LAYOUT_DEFAULT:
        }

        return false;
    }

    function getMenuSource(scope) {
        if (window.isMobile){
            return "MobileMenuNavigation.html";
        } else if (scope.layoutId === LAYOUT_DROPMEGA) {
            return "MegaDropNavigation.html";
        } else if (isMegaMenu(scope)) {
            return "MegaMenuNavigation.html";
        } else {
            return "DropdownNavigation.html";
        }
    }

    return {
        restrict: "E",
        replace: true,
        templateUrl: viewsLocation + "/MainMenuNavigation.html",
        scope: {},
        link: function (scope, elements, attrs, ctrl) {
            var data = angular.fromJson(attrs.menuData);
            var randomCssId = Math.round((Math.pow(10, 10) * Math.random())).toString(16);

            scope.randomId = randomCssId;
            scope.viewsLocation = viewsLocation;
            scope.items = data.items || [];
            scope.layoutId = data.layoutId || LAYOUT_DEFAULT;
            scope.name = data.name || "Menu";
            scope.cssId = Inflector.dasherise(data.name || randomCssId);
            scope.megaMenuNumCols = data.megaMenuNumCols || MEGAMENU_NUM_COLUMNS;
            scope.megaMenuColSize = Math.floor(12 / scope.megaMenuNumCols);
            scope.navClass = isMegaMenu(scope) ? "yamm" : "";
            scope.includeMenuSrc = viewsLocation + "/" + getMenuSource(scope);
            scope.categoryDepthLimit = data.categoryDepthLimit || DEFAULT_CATEGORY_DEPTH;
            scope.categoryListLimit = data.categoryListLimit || DEFAULT_LIST_LIMIT;
            scope.label = attrs.label;

            if (isMegaMenu(scope)) {
                scope.chunkedItems = getChunkedItems(scope);
            }

            scope.showThumbnails = function () {
                return scope.layoutId === "megamenu_thumbnails";
            };

            scope.setSubsectionContent = function(content) {
                scope.subsectionContent = content.items;
                $(".megamenu-content-column").removeClass (function (index, className) {
                    return (className.match (/(^|\s)submenu-\S+/g) || []).join(" ");
                });
                $(".megamenu-content-column").addClass("submenu-" + content.catId);
                $(".megamenu-content-column").attr("style", "display: flex !important");
            };

            scope.hasGrandChildren = function(items) {
                var children = _.some(items, function(value, key) {
                    return value.items;
                });

                return children;
            };
        }
    };
}]);
